import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-2 col-md-12" }

import { ref, reactive, watch } from 'vue';

interface Iprops {
    modelValue?: string | undefined,
    urlImagem?: string | undefined,

}

const width = 500
const height = 250


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modelValue: {},
    urlImagem: {}
  },
  emits: ['update:modelValue', 'salvar'],
  setup(__props: any, { emit: __emit }) {


var props = __props;

var controle = reactive({
    dataUrl: '',
    urlImagem: props.urlImagem,
    confirmada: false,
    status: '',
    erro: ''
})


var emit = __emit;

watch(() => props.urlImagem, (newVal) => {
    controle.urlImagem = newVal;
}, { immediate: true });

const canvasRef = ref(null)
const drawing = ref(false)
const saved = ref(false)
let ctx = null

function getPos(e) {
    if (e.touches) {
        if (!canvasRef.value) return { x: 0, y: 0 };
        const rect = canvasRef.value.getBoundingClientRect()
        return {
            x: e.touches[0].clientX - rect.left,
            y: e.touches[0].clientY - rect.top
        }
    } else {
        return {
            x: e.offsetX,
            y: e.offsetY
        }
    }
}

function startDrawing(e) {
    if (saved.value) return
    drawing.value = true
    if (!canvasRef.value) return;
    ctx = canvasRef.value.getContext('2d')
    const pos = getPos(e)
    ctx.beginPath()
    ctx.moveTo(pos.x, pos.y)
}

function draw(e) {
    if (!drawing.value || saved.value) return
    const pos = getPos(e)
    ctx.lineTo(pos.x, pos.y)
    ctx.stroke()
}

function stopDrawing() {
    drawing.value = false
}

function startDrawingTouch(e) {
    if (saved.value) return
    drawing.value = true
    ctx = canvasRef.value.getContext('2d')
    const pos = getPos(e)
    ctx.beginPath()
    ctx.moveTo(pos.x, pos.y)
}

function drawTouch(e) {
    if (!drawing.value || saved.value) return
    const pos = getPos(e)
    ctx.lineTo(pos.x, pos.y)
    ctx.stroke()
}

function clear() {
    if (controle.urlImagem)
    {
        controle.urlImagem = "";
    }
    else {

        console.log("limpando assinatura...");
        ctx = canvasRef.value.getContext('2d')
        ctx.clearRect(0, 0, width, height)
        saved.value = false
    }
}


 async function salvar() {

    console.log("salvando assinatura...");

    const canvas = canvasRef.value;
    if (!canvas) return;

    // Verificar se há algo desenhado no canvas
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    let hasDrawing = false;

    // Verificar se há pixels não brancos (indicando que algo foi desenhado)
    for (let i = 0; i < data.length; i += 4) {
      if (data[i] !== 255 || data[i + 1] !== 255 || data[i + 2] !== 255) {
        hasDrawing = true;
        break;
      }
    }

    if (!hasDrawing) {
      alert('Por favor, faça sua assinatura antes de confirmar.');
      return;
    }

    // Converter canvas para base64
    controle.dataUrl = canvas.toDataURL('image/png');
    controle.confirmada = true;

    try {
        controle.status = "Salvando assinatura...";
      
        // Aqui você faria a chamada para salvar a assinatura
        emit('update:modelValue', controle.dataUrl);
        emit('salvar', controle.dataUrl);
        console.log("salvando assinatura...", controle.dataUrl);

        controle.status = "Assinatura confirmada com sucesso!";

    } catch (error) {
        controle.erro = `Erro ao salvar assinatura: ${error}`;
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(controle).urlImagem)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(controle).urlImagem,
            width: width,
            height: height,
            class: "border rounded bg-white"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("canvas", {
            key: 1,
            ref_key: "canvasRef",
            ref: canvasRef,
            width: width,
            height: height,
            class: "border rounded bg-white",
            style: {"touch-action":"none"},
            onMousedown: startDrawing,
            onMousemove: draw,
            onMouseup: stopDrawing,
            onMouseleave: stopDrawing,
            onTouchstart: _withModifiers(startDrawingTouch, ["prevent"]),
            onTouchmove: _withModifiers(drawTouch, ["prevent"]),
            onTouchend: _withModifiers(stopDrawing, ["prevent"])
          }, null, 544))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (salvar())),
        class: "btn btn-sm btn-primary me-2"
      }, "Salvar"),
      _createElementVNode("button", {
        onClick: clear,
        class: "btn btn-sm btn-danger"
      }, "Limpar")
    ])
  ], 64))
}
}

})